var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import GarLogPerformanceConstants from "./GarLogPerformanceConstants.js";
import logger from "@ane/core/lib/services/logging/Logger";
const defaultGARPerformanceState = {
  pageLoadClientTime: null,
  stepPropertiesLoadTime: null,
  planSummaryLoadTime: null,
  autoShutdownLoadTime: null,
  alertsLoadTime: null,
  analysesLoadTime: null,
  scorecardsLoadTime: null,
  hypothesisLoadTime: null,
  slicesLoadTime: null,
  warningsLoadTime: null,
  metricCategoriesLoadTime: null,
  scorecardDataLoadTime: null,
  mainFunctionality: null,
  mainFunctionalityLoad: null,
  fullLoad: null
};
const performanceReducer = (state = defaultGARPerformanceState, action) => {
  var _a, _b;
  switch (action.type) {
    case GarLogPerformanceConstants.LOAD_START:
      return __spreadProps(__spreadValues({}, state), {
        pageLoadClientTime: action.payload.clientTimeInMs,
        mainFunctionality: null
      });
    case GarLogPerformanceConstants.SET_STEP_PROPERTIES:
      return __spreadProps(__spreadValues({}, state), {
        stepPropertiesLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_PLAN_SUMMARY:
      return __spreadProps(__spreadValues({}, state), {
        planSummaryLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_AUTOSHUTDOWN:
      return __spreadProps(__spreadValues({}, state), {
        autoShutdownLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_ALERTS:
      return __spreadProps(__spreadValues({}, state), {
        alertsLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_ANALYSES:
      return __spreadProps(__spreadValues({}, state), {
        analysesLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_SCORECARDS:
      return __spreadProps(__spreadValues({}, state), {
        scorecardsLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_HYPOTHESIS:
      return __spreadProps(__spreadValues({}, state), {
        hypothesisLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_SLICES:
      return __spreadProps(__spreadValues({}, state), {
        slicesLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_WARNINGS:
      return __spreadProps(__spreadValues({}, state), {
        warningsLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_METRIC_CATEGORIES:
      return __spreadProps(__spreadValues({}, state), {
        metricCategoriesLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.SET_SCORECARD_DATA:
      return __spreadProps(__spreadValues({}, state), {
        scorecardDataLoadTime: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        mainFunctionality: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          lastPartToLoad: action.payload.lastPartToLoad,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.MAIN_FUNCTIONALITY_LOAD:
      return __spreadProps(__spreadValues({}, state), {
        mainFunctionalityLoad: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          lastPartToLoad: action.payload.lastPartToLoad,
          warm: action.payload.warm
        }
      });
    case GarLogPerformanceConstants.FULL_LOAD:
      if (((_a = state.hypothesisLoadTime) == null ? void 0 : _a.timeSinceLoadStartInMs) == GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER && ((_b = state.hypothesisLoadTime) == null ? void 0 : _b.timeSinceLoadStartInMs) == GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER) {
        logger.trackEvent({
          measurements: {},
          name: "No FeatureRolloutMetadata Scenario",
          properties: {}
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        fullLoad: {
          timeSinceLoadStartInMs: action.payload.clientTimeInMs,
          lastPartToLoad: action.payload.lastPartToLoad,
          warm: action.payload.warm
        }
      });
    default:
      return state;
  }
};
export {
  performanceReducer as default,
  defaultGARPerformanceState,
  performanceReducer
};
//# sourceMappingURL=GarLogPeformanceReducer.js.map
